import React, { Fragment, useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from "@mui/material";
import Rating from '@mui/material/Rating';
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
import { BtnSend } from 'components/Common/Button';
import { AlertTitleTh, AxiosGet, AxiosPost, ResultAPI } from 'service/CommonFunction/TS_function';
import { SwAlert } from 'components/Common/Alert/AlertForm';
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import { useLocation, useNavigate } from 'react-router-dom';
import InputCustomLabel from 'components/Common/ElementInForm/InputCustomLabelFormItem';
import parse from 'html-react-parser';
import { i18n } from 'i18n';
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';
const i18nField = 'entities.ModalRating.fields';

const ModalRating = (props) => {

    const {
        IsOpen,
        setIsOpen,
        sVOCFormID,
        sResponeName = "-",
        setIsOpenSnackbar,
        setsSeveritySnackbar,
        setsMessageSnackbar,
        setIsAlertInfo,
        IsAlertInfo
    } = props;

    const { BlockUI, UnBlockUI } = FnBlock_UI();

    const navigate = useNavigate();

    const [lstQuestionnaire, setlstQuestionnaire] = useState([] as any)

    const schema = yup.object().shape({
        sDetail: yupFormSchemas.string(i18n(`${i18nField}.sFeedback`), { required: false }),
    });

    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
        criteriaMode: "firstError"
    })

    useEffect(() => {
        if(IsOpen == true)
        {
            GetOption();
        }
    }, [IsOpen])
    

    const GetOption =()=>{
        AxiosGet(`MasterData/GetQuestionnaire`, { "sLanguage": currentLanguage() }, (res) => {
            ResultAPI(res, null, () => {
                setlstQuestionnaire(res.result.data || [])
            })
        });
    }

    const onSubmitRating =()=>{

        // let IsPass = true;
        // let sMessage = "<div style={{textAlign:'center'}}>กรุณาประเมินคะแนนความพึงพอใจ</div>";
        // if(lstQuestionnaire !+ null && lstQuestionnaire.length > 0){
        //     lstQuestionnaire.forEach(item => {
        //         if(item.nScore == null || item.nScore === 0)
        //         {
        //             sMessage += `<p style='text-align:left;margin: 0;'>- ${item.label}</p>`
        //             IsPass = false;
        //         }
        //     });
        // }
        // if(IsPass)
        // {
        // }
        // else
        // {
        //     SwAlert.Warning("แจ้งเตือน", sMessage, () => {});
        // }

        let param = {
            "sVOCFormID": sVOCFormID,
            "sMode": "C",
            "IsRating": true,
            "lstQuestionnaire": lstQuestionnaire,
            "sRemark": form.getValues("sDetail") ?? null

        }
        SwAlert.Confirm(AlertTitleTh.Confirm, "คุณต้องการที่จะบันทึกข้อมูลใช่หรือไม่ ?", () => {
            setIsOpen(false)
            BlockUI();

            AxiosPost(`VOC/SaveVOCFormData`, param, (res) => {
                UnBlockUI();
                ResultAPI(res, null, () => {
                    if (res.statusCode === 200) {
                        setIsAlertInfo(true)
                    }
                    else {
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar(res.Message)
                        setsSeveritySnackbar("warning")
                        UnBlockUI();

                    }
                })
            }, null, null)
        })

       
    }

    const options = {
        replace: (domNode) => {
            if (domNode.attribs && domNode.attribs.class === 'remove') {
                return <></>;
            }
        },
    };

    return (
        <Dialog
            open={IsOpen}
            onClose={() => { setIsOpen(false) }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            maxWidth={"md"}
        >
            <DialogTitle>
                <Typography>{i18n(`${i18nField}.sSatisfactionRating`)}</Typography>

            </DialogTitle>
            <hr style={{ width: '100%', margin: '0' }} />
            <DialogContent>
                <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center" >
                    {
                        lstQuestionnaire.length > 0 ?
                        <>
                        {
                            lstQuestionnaire.map((item,ind)=>{
                                return(
                                    <Fragment key={`rate_${ind}`}>
                                        <Grid item xs={12} style={{ textAlign: 'center' }}>
                                            <Typography style={{fontWeight:500}}>{item?.sQuestion}</Typography>
                                        </Grid>
                                        <Grid item >
                                            <Rating
                                                name={`rate_${ind}`}
                                                size="large"
                                                precision={1}
                                                max={item?.nMaxScore}
                                                style={{
                                                    fontSize: '3.5rem'
                                                }}
                                                onChange={(e, value) => {
                                                    item.nScore = value;
                                                }}
                                            />
                                        </Grid>
                                    </Fragment>
                                )
                            })
                        }
                        </>
                        :
                        null
                    }
                    <Grid item xs={12} style={{ textAlign: 'left' }}>
                        <Typography style={{fontWeight:500}}>{i18n(`${i18nField}.sAdministrator`)}</Typography>
                        <Typography>{sResponeName}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <FormProvider {...form}>
                            <InputCustomLabel
                                id="sDetail"
                                name="sDetail"
                                label={i18n(`${i18nField}.sFeedback`)}
                                required={false}
                                multiline={true}
                                // maxLength={1000}
                                rows={4}
                                fullWidth
                            />
                        </FormProvider>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid container direction="row" justifyContent="center" alignItems="center" >
                    <Grid item>
                        <BtnSend txt={i18n(`${i18nField}.sGiveScore`)} onClick={() => {onSubmitRating()}} />
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default ModalRating